import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import CardLessDataTableWithSearch from "../datatables/CardLessDataTableWithSearch";
import LeadFollowupModal from "./LeadFollowupModal";
import FollowupHistoryModal from "./FollowupHistoryModal";
import moment from "moment";


class LeadsFollowupsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            followupModal: false,
            historyModal: false,
            individualStudentData: [],
            individualHistoryData: [],
            getFollowupData: this.props.getLeadFollowUpDetails
        }
    }
    articlecolumns = [
        {
            dataField: "lead_name",
            text: "Lead Name",
            sort: true,
        },

        {
            dataField: "father_name",
            text: "Father Name",
            sort: true,
        },
        {
            dataField: "next_followup_date",
            text: "Next Followup Date",
            sort: true,
        },
        {
            dataField: "status",
            text: "Lead Status",
            sort: true,
        },
        {
            dataField: "source",
            text: "Source",
            sort: true,
        },
        {
            dataField: "add_followup",
            text: "Lead Update",
            formatter: this.addFollowup.bind(this),
            sort: true,
        },
        {
            dataField: "followup_history",
            text: "History",
            formatter: this.followupHistory.bind(this),
            sort: true,
        },
    ];

    addFollowup(val, row) {
        console.log(row, "qqqqqqq")
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ followupModal: true, individualStudentData: row.individualStudentData })}>
                <Button variant="link" name="view" className="text-theme">
                <i className="fas fa-check-circle" style={{fontSize:"18px"}}/>
                </Button>
            </div>
        );
    };

    followupHistory(val, row) {
        console.log(row, "qqqqqqq")
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ historyModal: true, individualHistoryData: row.individualStudentData.followUp_History })}>
                <Button variant="link" name="view" className="text-theme">
                <i className="fas fa-eye text-primary mr-2" style={{fontSize:"18px"}}/>
                </Button>
            </div>
        );
    };



    tableData(data) {
        let returnData = [];
        data.map((mapData) => {
            let next_followup_date = ""
            if (mapData.nextFollowUpDate != "NaN") {
                next_followup_date = moment.unix(mapData.nextFollowUpDate).format("DD-MM-YYYY LT")
            } else {
                next_followup_date = `--`
            }
            const newObj = {
                lead_name: mapData.lead_name,
                father_name: mapData.father_name,
                next_followup_date: next_followup_date,
                status: mapData.status_name,
                source: mapData.source_name,
                individualStudentData: mapData
            }
            returnData.push(newObj);
        });
        return returnData;
    }

    render() {
        console.log("sttt", this.state);
        return (
            <Container>
                <Row className="mt-3">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                            <h2 className="title h5 mb-0">Student Follow Ups</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col xl={12} lg={12} md={12} sm={12}>
                        {
                            this.state.getFollowupData.length > 0 ?
                                (

                                    <CardLessDataTableWithSearch
                                        parentData={this.tableData(this.state.getFollowupData)}
                                        particlecolumns={this.articlecolumns}
                                        name="attendance"
                                    />

                                ) : (
                                    <Col ls={12} md={12} sm={12}>
                                        <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                    </Col>
                                )
                        }
                    </Col>
                </Row>
                <LeadFollowupModal
                    show={this.state.followupModal}
                    onHide={() => this.setState({ followupModal: false })}
                    stateData={this.state}
                    getCallStatusTypes={this.props.getCallStatusTypes}
                    getLeadStatusTypes={this.props.getLeadStatusTypes}
                />
                <FollowupHistoryModal
                    show={this.state.historyModal}
                    onHide={() => this.setState({ historyModal: false })}
                    stateData={this.state}
                />
            </Container>
        )
    }
}
export default LeadsFollowupsSection;